var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowAccordion',{attrs:{"model":_vm.model},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('div',{staticClass:"flex items-center"},[_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.model.percent)+"%")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }